import { FormGroup, TextField } from "@mui/material";
import { RewardCalculationTypeEditorProps } from "../../../../types/actionModule/editor/rewardCalculationTypeEditorTypes";
import { useTranslation } from "react-i18next";
import { isScoreMultiplyRewardCalculationTypeModel, ScoreMultiplyRewardCalculationTypeModel } from "../../../../types/actionModule/rewardCalculationType/scoreMultiplyRewardCalculationType";

export default function ScoreMultiplyRewardCalculationTypeEditor(props: RewardCalculationTypeEditorProps) {
    const { t } = useTranslation();

    const calculationType = props.value;

    if(!isScoreMultiplyRewardCalculationTypeModel(calculationType)) {
        return <>Invalid value</>
    }

    return <FormGroup>
        <TextField
            size="small"
            value={calculationType.factor}
            helperText={t("actionModules.rewardCalculationType.scoreMultiply.description")}
            onChange={(e) => props.onChanged({
                ...props.value,
                factor: Number(e.target.value)
            } as ScoreMultiplyRewardCalculationTypeModel)}
            label={t("actionModules.rewardCalculationType.scoreMultiply.factor")}
            variant="outlined"
        />
    </FormGroup>
}